// src/menu-items/finance.ts
//
// The monthly figures from v3-admintool. Own group rather than under Rates:
// rates are what we charge, these are what actually happened.
import { GraphUp, DataTransferBoth, ShopFourTiles, Building } from 'iconoir-react';

const finance = {
  id: 'finance-group',
  title: 'Finance',
  type: 'group',
  children: [
    {
      id: 'finance-overview',
      title: 'Overview',
      type: 'item',
      url: '/finance/overview',
      icon: GraphUp,
      breadcrumbs: true
    },
    {
      id: 'finance-carriers',
      title: 'Carriers',
      type: 'item',
      url: '/finance/carriers',
      icon: DataTransferBoth,
      breadcrumbs: true
    },
    {
      id: 'finance-resellers',
      title: 'Resellers',
      type: 'item',
      url: '/finance/resellers',
      icon: ShopFourTiles,
      breadcrumbs: true
    },
    {
      id: 'finance-wholesales',
      title: 'Wholesales',
      type: 'item',
      url: '/finance/wholesales',
      icon: Building,
      breadcrumbs: true
    }
  ]
};

export default finance;
